import { render, staticRenderFns } from "./cookieAgree.vue?vue&type=template&id=bb219444"
import script from "./cookieAgree.vue?vue&type=script&lang=js"
export * from "./cookieAgree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports